import { css } from '@emotion/react'
import {
  cssVar,
  LineWeight,
  ThemedFocusIndicator,
  Timing,
  Transition,
} from '@opallabs/gem'

const rootClassName = 'lapidary-button-like'
// Intentionally no `root` selector, because `<ButtonBase>` should always be wrapped in a component with its own
// root selector.
export const selectors = {
  icon: `${rootClassName}-icon`,
  label: `${rootClassName}-label`,
} as const

const cssVariablePrefix = '--button'
export const cssVariables = {
  backgroundColor: `${cssVariablePrefix}-bg-color`,
  strokeColor: `${cssVariablePrefix}-stroke-color`,
  textColor: `${cssVariablePrefix}-text-color`,
  hoverBackgroundColor: `${cssVariablePrefix}-hover-bg-color`,
  hoverStrokeColor: `${cssVariablePrefix}-hover-stroke-color`,
  activeBackgroundColor: `${cssVariablePrefix}-active-bg-color`,
  activeStrokeColor: `${cssVariablePrefix}-active-stroke-color`,
  activeTextColor: `${cssVariablePrefix}-active-text-color`,
} as const

export const base = css({
  '@layer lapidary': {
    alignItems: 'center',
    backgroundColor: cssVar(cssVariables.backgroundColor, 'transparent'),
    borderColor: cssVar(cssVariables.strokeColor, 'transparent'),
    borderStyle: 'solid',
    borderWidth: LineWeight.Small,
    color: cssVar(cssVariables.textColor, 'currentcolor'),
    contain: 'content',
    display: 'flex',
    justifyContent: 'center',
    maxInlineSize: '100%',
    ...Transition(['background-color', 'border-color', 'box-shadow', 'color'], {
      duration: Timing.Fastest,
    }),

    '&[aria-disabled=true], &:disabled': {
      opacity: 0.5,
    },
    '&:not([aria-disabled=true]):not(:disabled)': {
      cursor: 'pointer',

      '&:focus-visible': ThemedFocusIndicator,
      '&:focus-visible, &:hover': {
        backgroundColor: cssVar(cssVariables.hoverBackgroundColor),
        borderColor: cssVar(cssVariables.hoverStrokeColor, 'transparent'),
      },
      '&:active, &[aria-checked=true], &[aria-pressed=true], &[aria-selected=true]':
        {
          backgroundColor: cssVar(cssVariables.activeBackgroundColor),
          borderColor: cssVar(cssVariables.activeStrokeColor, 'transparent'),
          color: cssVar(
            cssVariables.activeTextColor,
            cssVar(cssVariables.textColor)
          ),
        },
    },

    '@media (forced-colors: active)': {
      '&:not([aria-disabled=true]):not(:disabled):focus-visible': {
        outlineColor: 'ButtonText',
        outlineStyle: 'solid',
        outlineWidth: LineWeight.Large,
      },
      '&:not([aria-disabled=true]):not(:disabled)': {
        '&:active, &[aria-checked=true], &[aria-pressed=true], &[aria-selected=true]':
          {
            backgroundColor: 'SelectedItem',
            color: 'SelectedItemText',
          },
      },
    },
  },
})
